import React from 'react';



const useLang = (locale) => {
    const [lang, setLang] = React.useState('');

    React.useEffect(() => {
        const lang = locale
        if (lang) {
            setLang(lang);
        }
    }, []);

    const setLangToLocalStorage = (lang) => {
        console.error(2, lang)
        setLang(lang);
    };

    return [lang, setLangToLocalStorage ];
};

export default useLang;
